import React, { useState, useMemo } from 'react'
import { actualizarDatos } from '../../api/common'
import { Alertassw } from '../Alertas/Alertassw'
import { Permisos } from './Permisos'

export const ModalPermisos = ({ rol, cambiarestado, setRefresh, refresh, setSpinnerMod }) => {
    const todoPermisos = Permisos().filter(p => p !== '')

    const [selected, setSelected] = useState(() => new Set(rol?.permisos || []))

    const initialSet = useMemo(() => new Set(rol?.permisos || []), [rol])

    const hasChanges = useMemo(() => {
        if (selected.size !== initialSet.size) return true
        for (const p of selected) {
            if (!initialSet.has(p)) return true
        }
        return false
    }, [selected, initialSet])

    const togglePermiso = (permiso) => {
        setSelected(prev => {
            const next = new Set(prev)
            if (next.has(permiso)) {
                next.delete(permiso)
            } else {
                next.add(permiso)
            }
            return next
        })
    }

    const saveChanges = async () => {
        if (!hasChanges) return
        setSpinnerMod(true)
        try {
            await actualizarDatos('Roles', {
                _id: rol._id,
                permisos: [...selected]
            })
            Alertassw('charge', 'Permisos actualizados correctamente')
            setRefresh(r => !r)
            cambiarestado(false)
        } catch (error) {
            Alertassw('error', 'Ha ocurrido un error', 'Intenta nuevamente, si el error persiste reporta el fallo a soporte técnico')
        }
        setSpinnerMod(false)
    }

    return (
        <div className='modal-permisos'>
            <p className='permisos-hint'>
                Selecciona o quita permisos para el rol <strong>{rol?.nombre}</strong>.
                Los permisos marcados ya están asignados.
            </p>
            <div className='permisos-grid'>
                {todoPermisos.map((permiso, i) => (
                    <label
                        key={i}
                        className={`permiso-item ${selected.has(permiso) ? 'permiso-activo' : ''}`}
                        onClick={() => togglePermiso(permiso)}
                    >
                        <input
                            type='checkbox'
                            checked={selected.has(permiso)}
                            onChange={() => togglePermiso(permiso)}
                            onClick={e => e.stopPropagation()}
                        />
                        <span>{permiso}</span>
                    </label>
                ))}
            </div>
            <div className='permisos-footer'>
                <span className='permisos-counter'>
                    {selected.size} permiso{selected.size !== 1 ? 's' : ''} asignado{selected.size !== 1 ? 's' : ''}
                </span>
                <button
                    className={`btn-btn-primary permisos-save-btn ${!hasChanges ? 'permisos-save-disabled' : ''}`}
                    onClick={saveChanges}
                    disabled={!hasChanges}
                    title={hasChanges ? 'Guardar cambios de permisos' : 'No hay cambios pendientes'}
                >
                    {hasChanges ? (
                        <><i className='bi bi-floppy-fill'></i> Guardar cambios</>
                    ) : (
                        <><i className='bi bi-check-circle'></i> Sin cambios</>
                    )}
                </button>
            </div>
        </div>
    )
}
